import React, { Component } from 'react';
import './Settings.css';
import axios from 'axios';
import { Icon } from 'element-react';
import { BASE_HOST_URL } from '../../config';

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settings: {
        lastInvoiceId: null,
      },
      saving: false
    };
  }

  async componentDidMount() {
    try {
      const { data: { settings } } = await axios.get(`${BASE_HOST_URL}/api/v1/settings`);
      this.setState({
        settings: {
          ...this.state.settings,
          _id: settings[0]._id,
          lastInvoiceId: ('000000' + settings[0].lastInvoiceId).slice(-6)
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  onIdChange = async (event) => {
    try {
      const newInvoiceValue = ('000000' + event.target.value).slice(-6);

      this.setState({
        settings: {
          ...this.state.settings,
          lastInvoiceId: newInvoiceValue,
        },
        saving: true
      });

      await axios.put(`${BASE_HOST_URL}/api/v1/settings`, { settings: { ...this.state.settings, lastInvoiceId: parseInt(newInvoiceValue) } });
    } catch (err) {
      alert('Error');
    } finally {
      this.setState({
        saving: false
      });
    }
  }

  render() {
    return (
      <div className="settingsWrapper">
        <label>
          Último id de factura:
          {this.state.settings.lastInvoiceId
            ? <input
              type="number"
              name="name"
              value={this.state.settings.lastInvoiceId}
              onInput={this.onIdChange}
            />
            : <Icon name={'loading'} style={{ padding: 8 }} />}
        </label>

        <span> -> A-{this.state.settings.lastInvoiceId}</span>

        {this.state.saving &&
          <p>Guardando <Icon name={'loading'} style={{ padding: 8 }} /></p>}
      </div>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js